export default {
    mainColor: "#fd7811",
    canUseColor: "#a3a3a3"
}